import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_share_jax_10febc28acbe646984ba0447566c753f",
  "use": "icon_share_jax_10febc28acbe646984ba0447566c753f-usage",
  "viewBox": "0 0 23 21",
  "content": "<symbol viewBox=\"0 0 23 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_share_jax_10febc28acbe646984ba0447566c753f\"><path d=\"M21.687 15.063v1.853c0 1.534-1.22 2.778-2.725 2.778H3.513c-1.506 0-2.726-1.244-2.726-2.778v-1.853m10.45-13.316v12.635m-6.65-5.856l6.65-6.779 6.65 6.78\" stroke-width=\"1.2\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol